export default "__VITE_ASSET__Bawf6PJ0__"